import { cva } from 'class-variance-authority';

export const cookieBannerStyles = cva(
  'tw:fixed tw:bottom-0 tw:left-0 tw:right-0 tw:z-[9998] tw:bg-white tw:border-t tw:border-gray-light tw:shadow-lg tw:p-base tw:md:p-large',
);

export const cookieModalOverlayStyles = cva(
  'tw:fixed tw:inset-0 tw:z-[9999] tw:bg-black/50 tw:flex tw:items-center tw:justify-center tw:p-base',
);

export const cookieModalContentStyles = cva(
  'tw:bg-white tw:rounded-16 tw:shadow-xl tw:w-full tw:max-w-lg tw:max-h-[90vh] tw:overflow-y-auto tw:p-large',
);

export const cookieToggleRowStyles = cva(
  'tw:flex tw:items-center tw:justify-between tw:py-base tw:border-b tw:border-gray-lighter',
);
